export enum ScreenToShowOn {
  ShowOn_InvoicesList = 1,
  ShowOn_InvoiceBatches = 2,
}
